import React from 'react';
import PropTypes from 'prop-types';

const PreText = ({ text }) => (
    <div className={'row pre-text-row'}>
        <div className={'pre-text col-12'}>{text}</div>
    </div>
);

PreText.propTypes = {
    text: PropTypes.string
};

export default PreText;
